import { useS4LContext } from '@s4l/react-context'
import { useEffect, useRef } from 'react'

export const SearchExecuter = () => {
  const { domain } = useS4LContext()
  const hasUserInteracted = useRef(false)

  useEffect(() => {
    const onSearch = async () => {
      const promises = Promise.all([
        domain.GetCurrentMarketSharedUseCase.execute(),
        domain.GetFeatureFlagByNameSharedUseCase.execute({
          name: 'SEARCH_ON_DOMAIN',
        }),
      ])

      const [[marketError, market], [featureFlagError, featureFlag]] = await promises

      if (marketError || featureFlagError) return

      if (!featureFlag || !featureFlag.isEnabled()) return

      const markets = featureFlag?.metadata?.markets

      if (!markets || !Array.isArray(markets)) return

      if (!markets.includes(market?.value)) return

      await domain.SearchFromPartialAndCriteriaPropertyUseCase.execute({
        offset: 0,
        page: 1,
        hasUserInteracted: hasUserInteracted.current,
      })

      hasUserInteracted.current = true
    }

    domain.on('CreateSearchCriteriaPropertyUseCase', onSearch)
    domain.on('CreateSearchPropertyUseCase', onSearch)

    return () => {
      domain.off('CreateSearchCriteriaPropertyUseCase', onSearch)
      domain.off('CreateSearchPropertyUseCase', onSearch)
    }
  }, [domain])

  return null
}
SearchExecuter.displayName = 'SearchExecuter'

export default SearchExecuter
